module.exports = __webpack_public_path__ + "img/m-home-banner-normal.9b3c2be1.webp";